var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-sm btn-primary",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.showFileManager()}}},[_vm._v(_vm._s(_vm.buttonText))])
}
var staticRenderFns = []

export { render, staticRenderFns }